// Keep these customer defaults aligned with the Shopify extension's appearance.ts.
export const APPEARANCE_DEFAULTS = {
  en: {
    title: 'Edit your order',
    subtitle: 'Make changes while your order is eligible.',
    editTitle: 'Shipping Address',
    cancelTitle: 'Cancel this order',
    cancelDescription:
      'Cancelling stops order processing permanently. This action cannot be reversed.',
    saveLabel: 'Save address',
    cancelLabel: 'Cancel Order',
    confirmLabel: 'Yes, cancel order',
    backLabel: 'No, go back',
  },
  es: {
    title: 'Editar pedido',
    subtitle: 'Haz cambios mientras tu pedido permita modificaciones.',
    editTitle: 'Dirección de envío',
    cancelTitle: 'Cancelar este pedido',
    cancelDescription:
      'La cancelación detiene el procesamiento del pedido de forma permanente. Esta acción no se puede deshacer.',
    saveLabel: 'Guardar dirección',
    cancelLabel: 'Cancelar pedido',
    confirmLabel: 'Sí, cancelar pedido',
    backLabel: 'No, volver',
  },
  fr: {
    title: 'Modifier votre commande',
    subtitle: 'Modifiez votre commande tant que cela est possible.',
    editTitle: 'Adresse de livraison',
    cancelTitle: 'Annuler cette commande',
    cancelDescription:
      'L’annulation arrête définitivement le traitement de la commande. Cette action est irréversible.',
    saveLabel: 'Enregistrer l’adresse',
    cancelLabel: 'Annuler la commande',
    confirmLabel: 'Oui, annuler la commande',
    backLabel: 'Non, revenir',
  },
};
